import customerFeedbackInputData from './inputData/software-development-quiz';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'software-development-quiz',
  title: 'Software Development Quiz',
  description: 'Think you know your SOLID from your DRY? Test your dev knowledge with this quick, interactive quiz.',
  image: '/images/templates/software-development-quiz.png',
  tags: ['human-resources', 'recruit-talent'],
  inputData: customerFeedbackInputData,
  formPreview: convertDraftParamsToLeadForm(customerFeedbackInputData(),
    previewInput
  ),
}

export default template;

